import PropTypes from 'prop-types';
import { useContext } from 'react';
import MyContext from '../context/MyContext';
import texts from '../services/texts';
import BurgerMenu from './BurgerMenu';
import Menu from './Menu';
import ProjectCards from './ProjectCard';

export default function Projects({ self }) {
  const { language } = useContext(MyContext);

  return (
    <>
      {self && (
      <>
        <Menu />
        <BurgerMenu />
      </>
      )}
      <div className="made-by-me glass-center">
        <div>
          <div className="projects">
            <h2>
              {texts.projects[language].title.split('').map(
                (letter, index) => (
                  <span className="hero" key={Math.random()} style={{ animationDelay: `${index * 70}ms` }}>
                    { letter }
                  </span>
                ),
              )}
            </h2>
            {self
        && (
        <div className="project-self-text">
          <span>
            {texts.projects[language].text}
            {' '}
          </span>
          <span>
            <a href="https://www.betrybe.com/" target="_blank" rel="noreferrer">Trybe.</a>
          </span>
        </div>
        )}
            <div className="projects-cards">
              <ProjectCards />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

Projects.propTypes = {
  self: PropTypes.bool.isRequired,
};
